import { Toast } from "vant";
import { linkInfo } from "@/api/talentPlaza";

const state = {
  linkInfo: {},
};
const mutations = {
  setStateItem(state, data) {
    state[data.key] = data.value;
  },
};
const actions = {
  getLinkInfo({ state, commit }, params) {
    return linkInfo(params)
      .then((res) => {
        if (res&&res.data&&res.data.code == 200) {
          commit("setStateItem", {
            key: "linkInfo",
            value: res.data.data,
          });
          return res.data.data;
        } else {
          Toast(res.data.message);
        }
      })
      .catch((err) => {});
  },
};

export default {
  state,
  actions,
  mutations,
  namespaced: true,
};
